













































































import {
	defineComponent,
	PropType,
	computed,
	toRefs,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { isPastEvent } from '@front-app/views/home/events/filters';
import { PublicEventsBannerStore } from '@front-app/store/singletons/Events';
import { PublicGroup } from '@front-app/services/GroupsApi/GroupModel';
import { STATUS } from '@front-app/constants/state';
import { useEventRole } from '@front-app/hooks/useMembershipRole';

export default defineComponent({
	components: {
		FontAwesomeIcon,
	},
	props: {
		event: {
			type: Object as PropType<EventV2>,
			required: true,
		},
		group: {
			type: [Object, null] as PropType<PublicGroup | null>,
			required: false,
			default: () => (null),
		},
		bannerLocation: {
			type: String as PropType<BannerLocation>,
			required: true,
		},
		disableTracking: Boolean,
	},
	setup(props, ctx) {
		const banner = computed(() => PublicEventsBannerStore.get(props.event.id));
		const eventTags = computed(() => props.event.categories
			.concat(props.event.eventTypes.map((t) => ctx.root.$t(t)) as string[])
			.join(', '));
		const isPast = computed(() => isPastEvent(props.event));
		const startDate = computed(() => ctx.root.$d(new Date(props.event.startDate), 'long'));

		return {
			startDate,
			isPast,
			eventTags,
			eventRole: useEventRole(toRefs(props).event),
			banner,
			isLoading: computed(() => banner.value.status === STATUS.LOADING),
		};
	},
});
